import customAxios from '@Utils/Axios';

const getProjects = async sub => {
  const response = await customAxios.get(`/project?projectOwnerSub=${sub}`);
  return response;
};

const createProject = async project => {
  await customAxios.post('/project', { ...project });
};

const editProject = async project => {
  await customAxios.post('/project_edit', { ...project });
};

const deleteProject = async id => {
  await customAxios.post('/project_delete', { id });
};

export { createProject, editProject, getProjects, deleteProject };
